import React from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";

const OkButton = ({ children, ...rest }) => (
  <MDButton variant="contained" color="info" {...rest}>
    {children}
  </MDButton>
);

OkButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OkButton;
